import { type ActiveState, createEntityStore, type EntityState, Order } from '@datorama/akita';
import { type Sort, type Task } from 'types/models';
import { ReferencedArea, TaskActionType, type TaskActionTypeEnum, TaskCycle, TaskStatus } from 'utils/enum';

export interface TasksState extends EntityState<Task>, ActiveState {
   statistics: Record<string, any>;
   exports: Task[];
   type: TaskActionTypeEnum;
   searchTerm?: string;
   filters: Record<string, (string | number)[]>;
   sortOrder: Record<TaskActionTypeEnum, Sort>;
}

export type TaskFilters = TasksState['filters'][keyof TasksState['filters']];

export const initialState: Partial<TasksState> = {
   statistics: {},
   exports: [],
   type: TaskActionType.TASK,
   searchTerm: undefined,
   filters: {
      status: Array.from(Object.values(TaskStatus)),
      priority: [1, 2, 3, 4, 5],
      area: Array.from(Object.values(ReferencedArea)),
      creator: [],
      assignee: [],
      reviewer: [],
      kpiFieldId: [],
      cycle: Array.from(Object.values(TaskCycle)),
   },
   sortOrder: {
      [TaskActionType.ACTION]: {
         key: 'maturity',
         order: Order.DESC,
      },
      [TaskActionType.TASK]: {
         key: 'maturity',
         order: Order.DESC,
      },
      [TaskActionType.SUPPLIER_ACTION]: {
         key: 'maturity',
         order: Order.DESC,
      },
   },
};

const store = createEntityStore<TasksState>(initialState, { resettable: true, name: 'tasks' });

export default store;
